import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { icons } from './assets/icons';
import './index.css';

React.icons = icons;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
